export const inputClass =
  'w-full rounded-xl border border-slate-200/90 bg-white px-3.5 py-2.5 text-sm text-slate-900 shadow-sm transition-all placeholder:text-slate-400 focus:border-teal-500/60 focus:outline-none focus:ring-2 focus:ring-teal-500/20';

export const labelClass = 'mb-1.5 block text-xs font-medium text-slate-600';

export const tableWrapClass =
  'overflow-x-auto rounded-2xl border border-slate-200/75 bg-white/75 shadow-sm shadow-slate-900/[0.05] backdrop-blur-sm';

export const tableClass = 'min-w-full text-left text-sm';

export const theadClass =
  'bg-gradient-to-b from-slate-50 to-slate-100/80 text-xs font-semibold uppercase tracking-wide text-slate-500';

export const thClass = 'px-4 py-3.5 font-medium normal-case tracking-normal text-slate-700';

/** 站点 / 用户列表等「数据行」卡片 */
export const listRowClass =
  'flex flex-col gap-3 rounded-2xl border border-slate-200/80 bg-gradient-to-b from-white to-slate-50/35 p-4 shadow-sm shadow-slate-900/[0.04] transition-all duration-200 hover:border-slate-300/90 hover:shadow-md sm:flex-row sm:items-center sm:justify-between';

/** 工作台模块导览等小卡片 */
export const moduleTileClass =
  'rounded-2xl border border-slate-200/70 bg-gradient-to-br from-white via-slate-50/40 to-teal-50/15 px-4 py-3 shadow-sm shadow-slate-900/[0.04] transition hover:border-teal-200/70 hover:shadow-md';

/** 页面顶部轻提示（toast） */
export const toastBarClass =
  'rounded-2xl border border-amber-200/80 bg-gradient-to-r from-amber-50/95 to-orange-50/40 px-4 py-3 text-sm text-slate-800 shadow-sm shadow-amber-900/5';

/** 行内成功 / 错误提示块 */
export const inlineSuccessClass =
  'rounded-xl border border-emerald-200/90 bg-emerald-50/95 px-4 py-3 text-sm font-medium text-emerald-900 shadow-sm';

export const inlineErrorClass =
  'rounded-xl border border-rose-200/90 bg-rose-50/95 px-4 py-3 text-sm font-medium text-rose-900 shadow-sm';

/** 深色代码块（JSON 等） */
export const codePreClass =
  'max-h-[min(50vh,420px)] overflow-auto rounded-xl border border-slate-700/60 bg-slate-950 p-4 text-[11px] leading-relaxed text-emerald-100 shadow-inner shadow-black/30';

/** 说明性灰底区块（设置页小节） */
export const settingsPanelClass =
  'rounded-2xl border border-slate-200/75 bg-gradient-to-b from-slate-50/90 to-white/60 p-4 shadow-sm shadow-slate-900/[0.03]';
